

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingSystemTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accounting-system-transactions';
        this.Server =
            this.props.context.getState().server.accountingSystemTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'fromAccountId',
                label: 'fromAccount',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'accountingSystemAccounts',
                object: 'fromAccount',
                show: 'publicAddress'
            },
            {
                id: 'toAccountId',
                label: 'toAccount',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'accountingSystemAccounts',
                object: 'toAccount',
                show: 'publicAddress'
            },
            {
                id: 'amountFrom',
                label: 'amountFrom',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'amountTo',
                label: 'amountTo',
                alignRight: true,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'note',
                label: 'note',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'paymentDate',
                label: 'paymentDate',
                alignRight: false,
                cell: 'DateTime',
                displayGrid: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true,
                from: 'users',
                object: 'modifiedBy',
                show: 'email'
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: false,
                displayDialogDetails: true,
                disableEditor: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Json',
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

